<template>
    <van-toast :show="show" @update:show="emit('update:show', $event)" style="padding: 0" class="custom-toast">
        <template #message>
           <div>
            {{ message }}
           </div>
        </template>
    </van-toast>
</template>

<script setup lang="ts">
interface Props {
    show: boolean
    isAllTranslate: boolean
    message: string
}

const props = withDefaults(defineProps<Props>(), {
    show: false,
    isAllTranslate: false,
    message: ''
})

// 定义事件
const emit = defineEmits<{
    'update:show': [value: boolean]
}>()
</script>